import { Terminal } from "lucide-react";
import { useLocale } from "@/contexts/LocaleContext";

export function LoadingState() {
  const { t } = useLocale();
  return (
    <div className="flex flex-col items-center justify-center py-16 animate-fade-in">
      <div className="relative">
        <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center animate-pulse-glow">
          <Terminal className="w-8 h-8 text-primary" />
        </div>
        <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-primary/10 to-secondary/10 animate-ping" />
      </div>
      
      <div className="mt-6 space-y-2 text-center">
        <h3 className="text-lg font-semibold text-foreground">{t("loading.title")}</h3>
        <p className="text-sm text-muted-foreground">{t("loading.subtitle")}</p>
      </div>

      <div className="mt-6 flex items-center gap-1">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="w-2 h-2 rounded-full bg-primary animate-bounce"
            style={{ animationDelay: `${i * 150}ms` }}
          />
        ))}
      </div>
    </div>
  );
}
